module.exports = __webpack_public_path__ + "static/hss_logo_black_final.2af6ff25.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hss_logo_black_final.svg
// module id = 981
// module chunks = 220250618448524